import React, { useMemo } from 'react';
import _sortBy from 'lodash/sortBy';
import { useQuery } from '@apollo/client';
import ErrorMessage from '@minecraft.error-message';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerFiltersCounts } from '@minecraft.drawer';
import { FilterDrawerType, FiltersNameEnum } from '@blocs.filter';
import { SEEKING_REPRESENTATIONS_QUERY } from '../../FilterBasic/FilterBasicCollection/FilterBasicCollectionGraphQL';
import { FiltersCountNameEnum } from '../shared/types';
import { getCountsPerFilterName } from './getCountsPerFilterName';

export type SeekingRepresentationCategoryProps = {
  type: FilterDrawerType;
};

export const SeekingRepresentationCategory = () => {
  const { data, error } = useQuery(SEEKING_REPRESENTATIONS_QUERY);
  const { filtersCounts } = useDrawerFiltersCounts();

  // Filter and sort the seeking representation options:
  const options = useMemo(() => {
    if (data?.seekingRepresentations) {
      const docCounts = getCountsPerFilterName({
        filtersCounts,
        nameEnum: FiltersCountNameEnum.seekingRepresentations,
      });

      const filteredItems = data.seekingRepresentations.reduce((acc, representation) => {
        if (representation.enabled) {
          acc.push({
            label: representation.name,
            value: representation.id,
            count: docCounts?.[representation.id] ?? 0,
          });
        }

        return acc;
      }, []);

      return _sortBy(filteredItems, 'sortOrder');
    }

    return [];
  }, [data]);

  if (error) return <ErrorMessage error={error} />;

  return (
    <CheckboxListWithSearch withSelectAll withFormik name={FiltersNameEnum.seekingRepresentation} options={options} />
  );
};
